import Vue from 'vue'
import Router from 'vue-router'

import EventsOverview from '@/pages/EventsOverview'
import ViewPointOfSale from "@/pages/ViewPointOfSale";

import ClaimTicket from '@/pages/ClaimTicket'
import TicketClaimed from '@/pages/TicketClaimed'
import OrderEnterPersonalDetails from "@/pages/OrderEnterPersonalDetails";
import OrderSelectTimeslot from "@/pages/OrderSelectTimeslot";
import OrderSelectPaymentMethod from "@/pages/OrderSelectPaymentMethod";
import OrderAdditionalProducts from "@/pages/OrderAdditionalProducts";
import OrderStatus from "@/pages/OrderStatus";
import CustomerOrderDetails from "@/pages/CustomerOrderDetails";
import CustomerOrderPending from "@/pages/CustomerOrderPending";
import AssignTickets from "@/pages/AssignTickets";
import OrderThankYou from "@/pages/OrderThankYou";
import NotFound from '@/pages/NotFound'
import TermsConditions from '@/pages/TermsConditions'
import TicketChanged from "@/pages/TicketChanged";
import AccessDenied from "@/pages/AccessDenied";
import TicketLost from "../pages/TicketLost";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: EventsOverview
        },
        {
            path: '/p/:url',
            name: 'ViewPointOfSale',
            component: ViewPointOfSale
        },
        {
            path: '/order/:id/:secret/personal',
            name: 'OrderEnterPersonalDetails',
            component: OrderEnterPersonalDetails
        },
        {
            path: '/order/:id/:secret/timeslot',
            name: 'OrderSelectTimeslot',
            component: OrderSelectTimeslot
        },
        {
            path: '/order/:id/:secret/products',
            name: 'OrderAdditionalProducts',
            component: OrderAdditionalProducts
        },
        {
            path: '/order/:id/:secret/payment',
            name: 'OrderSelectPaymentMethod',
            component: OrderSelectPaymentMethod
        },
        {
            path: '/order/:id/:secret/overview',
            name: 'CustomerOrderOverview',
            component: CustomerOrderDetails
        },
        {
            path: '/order/:id/:secret/pending',
            name: 'CustomerOrderPending',
            component: CustomerOrderPending
        },
        {
            path: '/order/:id/:secret/assign',
            name: 'AssignTickets',
            component: AssignTickets
        },
        {
            path: '/order/thanks',
            name: 'OrderThankYou',
            component: OrderThankYou
        },
        {
            path: '/order/:id/:secret/status',
            name: 'OrderStatus',
            component: OrderStatus
        },
        {
            path: '/ticket/:id/:secret/claim',
            name: 'ClaimTicket',
            component: ClaimTicket
        },
        {
            path: '/ticket/claimed',
            name: 'TicketClaimed',
            component: TicketClaimed
        },
        {
            path: '/404',
            name: 'NotFound',
            component: NotFound
        },
        {
            path: '/terms-conditions',
            name: 'TermsConditions',
            component: TermsConditions
        },
        {
            path: '/ticked-changed',
            name: 'TicketChanged',
            component: TicketChanged
        },
        {
            path: '/403',
            name: 'AccessDenied',
            component: AccessDenied
        },
        {
          path: '/ticket-lost',
          name: 'TicketLost',
          component: TicketLost
        }
    ]
})

export default router;
